import { colors } from "@/styles/colors"
import { isSmallScreen } from "@/utils/checkDevice"
import ColorUtil from "@/utils/ColorUtil"

import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles((theme) => ({
	button: {
		...ColorUtil.getBackgroundAndContrastColor(colors.getPrimaryColor()),
		transition: theme.transitions.create("all", {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen
		}),
		"&:hover": {
			...ColorUtil.getBackgroundAndContrastColor(colors.gray[0]),
			opacity: 0.9
		}
	},
	contentContainer: {
		display: "flex",
		justifyContent: "center"
	},
	paper: {
		margin: theme.spacing(2),
		zIndex: 1600,
		...ColorUtil.getBackgroundAndContrastColor("transparent"),
		boxShadow: "none"
	},
	drawerPaper: {
		width: `${isSmallScreen && "100vw"}`,
		...ColorUtil.getBackgroundAndContrastColor("transparent")
	},
	paperFullWidth: {
		width: "calc(100% - 32px)",
		...ColorUtil.getBackgroundAndContrastColor("transparent")
	},
	logo: {
		display: "block",
		margin: "0 auto",
		maxWidth: "120px",
		height: "auto"
	}
}))

export default useStyles
